export var InfoType;

(function (InfoType) {
  InfoType["UserPlaylist"] = "user_playlist";
  InfoType["Series"] = "series";
  InfoType["Season"] = "series_season";
  InfoType["Channel"] = "channel";
  InfoType["ChannelEdition"] = "channel_edition";
  InfoType["ChannelEditionPlaylist"] = "channel_edition_playlist";
})(InfoType || (InfoType = {}));